import { FloorLampDualIcon } from './FloorLampDualIcon';

/**
 * author: Borre Haugen
 * id 08F74DD4-A57F-4CC8-9568-88E826BE71E5
 * name floor-lamp-dual
 * version: 4.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/floor-lamp-dual.svg
 * tags
 * - Home Automation 
 */
export const FloorLightDualIcon = FloorLampDualIcon;
export default FloorLightDualIcon